<app-reports-toolbar></app-reports-toolbar>
<app-notification-message [errorMessage]="errorMessage" [successMessage]="successMessage">
</app-notification-message>
<div class="container-fluid px-0">
  <form [formGroup]="form" (ngSubmit)="downloads()">
    <!-- -->
    <div class="row ms-4 me-3">
      <div class="me px-0">
        <div id="id1">
          <div class="_date">
            Start Date
            <span>*</span>
          </div>
        </div>

        <div>
          <input type="date" [min]="minDate" [max]="yesterday" onkeydown="return false"
            (change)="onDateChangedEnd($event)" class="form-control" id="start_Date" name="start_Date"
            formControlName="start_Date" />
          <p *ngIf="form.controls['start_Date'].errors?.['required']
                        && (form.controls['start_Date'].touched || submitted )">
            Start date Required
          </p>
        </div>

        <div id="id2">
          <div class="_date">
            End Date
            <span>*</span>
          </div>
        </div>
        <div>
          <input type="date" [min]="newDate" [max]="maxDate" (change)="onDateChangedStart($event)"
            onkeydown="return false" class="form-control" id="end_Date" name="end_Date" formControlName="end_Date" />
          <p *ngIf="form.controls['end_Date'].errors?.['required']
                        && (form.controls['end_Date'].touched || submitted )">
            End date Required
          </p>
          <p *ngIf="
              form.hasError('invalidDate') &&
              (form.controls['end_Date'].touched ||
                form.controls['end_Date'].dirty) &&
              submitted
            ">
            End Date is invalid
          </p>
        </div>

        <div id="id3">NAMC/PDC</div>
        <div>

          <mat-select id="plant" name="namc" formControlName="plant" class="mat-sel diff" [panelWidth]="null" disableOptionCentering>
            <mat-option *ngFor="let namc of dropdownOptionHistoryPlant" [value]="namc.value">{{ namc.value
              }}</mat-option>
          </mat-select>

        </div>
      </div>
    </div>

    <div class="row ms-4 me-3">
      <div class="me px-0">
        <div id="id1">Region</div>

        <div>
          <mat-form-field appearance="outline" class="fixed-select" style="height:26px !important">

            <mat-select formControlName="region" multiple [panelWidth]="null">

              <!-- SELECT ALL + SEARCH HEADER -->
              <div class="search-all-option">
                <mat-checkbox
                  [checked]="isAllSelected(form.get('region')?.value, dropdownOptionHistoryRegion)"
                  [indeterminate]="isIndeterminate(form.get('region')?.value, dropdownOptionHistoryRegion)"
                  (change)="toggleSelectAll('region', $event)">
                </mat-checkbox>

                <ngx-mat-select-search [formControl]="regionFilterCtrl" placeholderLabel="Search"
                  noEntriesFoundLabel="No options found">
                </ngx-mat-select-search>
              </div>

              <!-- OPTIONS -->
              <div style="max-height: 195px; overflow-y: auto;">
                <mat-option *ngFor="let d of filteredRegion | async" [value]="d" style="font-size: 13px;">
                  {{ d.value }}
                </mat-option>
              </div>

            </mat-select>

          </mat-form-field>
        </div>

        <div id="id2">
          <label>Event Type</label>
        </div>
        <div>

          <mat-form-field appearance="outline" class="fixed-select" style="height:26px !important">

            <mat-select formControlName="event_Type" multiple [panelWidth]="null">
              <div class="search-all-option">
                <mat-checkbox
                  [checked]="isAllSelected(form.get('event_Type')?.value, dropdownOptionHEvent)"
                  [indeterminate]="isIndeterminate(form.get('event_Type')?.value, dropdownOptionHEvent)"
                  (change)="toggleSelectAll('event', $event)">
                </mat-checkbox>
                <ngx-mat-select-search [formControl]="eventFilterCtrl" placeholderLabel="Search"
                  noEntriesFoundLabel="No options found">
                </ngx-mat-select-search>
              </div>
              <div style="max-height: 195px; overflow-y: auto;">
                <mat-option *ngFor="let d of filteredEvent | async" [value]="d" style="font-size: 13px;">
                  {{ d.value }}
                </mat-option>
              </div>
            </mat-select>
          </mat-form-field>


        </div>

        <div id="idTransport">
          <label>Resolution Type</label>
        </div>
        <div>

          <mat-form-field appearance="outline" class="fixed-select" style="height:26px !important">
            <mat-select formControlName="reso_Type" multiple [panelWidth]="null">
              <div class="search-all-option">
                <mat-checkbox
                  [checked]="isAllSelected(form.get('reso_Type')?.value, dropdownOptionHResolution)"
                  [indeterminate]="isIndeterminate(form.get('reso_Type')?.value, dropdownOptionHResolution)"
                  (change)="toggleSelectAll('resolution', $event)">
                </mat-checkbox>
                <ngx-mat-select-search [formControl]="resFilterCtrl" placeholderLabel="Search"
                  noEntriesFoundLabel="No options found">
                </ngx-mat-select-search>
              </div>
              <div style="max-height: 195px; overflow-y: auto;">
                <mat-option *ngFor="let d of filteredRes | async" [value]="d" style="font-size: 13px;">
                  {{ d.value }}
                </mat-option>
              </div>
            </mat-select>
          </mat-form-field>

        </div>
      </div>
    </div>

    <div class="row ms-4 me-3">
      <div class="me ps-0">
        <div id="id1">
          <button type="submit" class="roboto-bold" id="btn" (click)="submitted = true">
            FETCH REPORT
          </button>
        </div>
      </div>
    </div>
  </form>
</div>